import { render, staticRenderFns } from "./ThinFilmInterferenceViz.vue?vue&type=template&id=19d6d990&scoped=true"
import script from "./ThinFilmInterferenceViz.vue?vue&type=script&lang=js"
export * from "./ThinFilmInterferenceViz.vue?vue&type=script&lang=js"
import style0 from "./ThinFilmInterferenceViz.vue?vue&type=style&index=0&id=19d6d990&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d6d990",
  null
  
)

export default component.exports